import { Grid, Tooltip } from "@material-ui/core";
import { LotSelectorStyle, } from "./style";
import { IconLot } from "icons";

export const LotSelector = ({
    lotName,
    lotId,
    lotLookup
}) => {
    const classes = LotSelectorStyle();

    const outOfOrgText = "Assigned to a lot that is not visible to you";

    return (<Grid container  >
        <Tooltip title={(!lotName && !lotLookup?.[lotId]?.name) ? outOfOrgText : ''}>
            <Grid item className={classes.iconWrapper}>
                <IconLot />
            </Grid>
        </Tooltip>
        <Grid item className={classes.text}>{lotName ?? lotLookup?.[lotId]?.name}</Grid>
    </Grid>
    )
}
